// Pure unread computation for chats/channels (.kiro/specs/1596-chat-notifications-rework).
// No React/Redux/Firebase imports — unit-testable in isolation (Vitest:
// chatUnread.test.js), same split as this folder's own athleteChat.js
// (athleteChatId) and performanceHub's builderInputs.js.
//
// Replaces the old race-prone model: a mutable `unreadChats` array
// (notifications/{userId}, arrayUnion/read-filter-write) for chats, and a
// mutable `notificationIds` array (channels/{id}.lastMessage.notificationIds,
// arrayRemove) for channels. A conversation is now unread when its
// lastMessage is newer than the reader's own read-receipt timestamp, stored
// directly on the conversation doc (readReceipts.{userId}, a single atomic
// field write — see firebaseFunctions.js's markChatRead/markChannelRead).
//
// `userId` is passed around this codebase as both a string (Redux auth state)
// and a number (GraphQL results) — String(...) on both sides of the sender
// comparison sidesteps that, same defensive pattern athleteChatId already
// uses via String()/+.
export const isConversationUnread = (lastMessage, readReceipts, userId) => {
  if (!lastMessage) return false;
  if (String(lastMessage.senderId) === String(userId)) return false;
  const lastRead = readReceipts?.[userId] ?? 0;
  return (lastMessage.createdAt || 0) > lastRead;
};
